// utilities
import api from '@/utilities/api'
export const getParkingBookings = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/parkingBookings',
    success (response) {
      commit('setParkingBookings', response.data)
    }
  })
}
export const getParkingBooking = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/parkingBookings/' + payload.parkingBookingID,
    success (response) {
      commit('setParkingBooking', response.data)
    }
  })
}
export const deleteParkingBookings = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/parkingBookings',
    payload
  })
}
export const updateParkingBookingVehicle = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'put',
    endpoint: 'private/parkingBookings/' + payload.parkingBookingID + '/vehicle',
    payload,
    success (response) {
      dispatch('getParkingBookings')
    }
  })
}
